import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { addGeneralPoolFundsToMember } from '../../../../../api/homeless';
import { fetchUpdatedMemberBalanceRequest } from '../../../../../redux/actions/debit_card';

interface UseAdminMemberGPFundReturn {
  addFundsToMember: (memberId: number, amount: number) => Promise<void>;
  isLoading: boolean;
  error: string | null;
}

export const useAdminMemberGPFund = (): UseAdminMemberGPFundReturn => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const addFundsToMember = async (memberId: number, amount: number): Promise<void> => {
    setIsLoading(true);
    setError(null);

    try {
      await addGeneralPoolFundsToMember(memberId, amount);
      // Refresh the member's balance in Redux after successful transfer
      dispatch(fetchUpdatedMemberBalanceRequest(memberId) as any);
    } catch (err: any) {
      const errorMessage = err?.message || 'Failed to add funds to member balance';
      setError(errorMessage);
      throw new Error(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    addFundsToMember,
    isLoading,
    error
  };
};
